import React, { useState } from 'react';

import { useNavigation } from '@react-navigation/native';

import { Button } from '@/components/ButtonComponent';
import { SheetScreen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { Text } from '@/components/TextComponent';
import { TextInput } from '@/components/TextInput';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

const BULLETS = [
    'previous screen peeks through underneath, dimmed',
    'dismiss by swiping down or tapping close',
    'use it for edit or action screens, or informational screens that branch off the current context',
    'sheet() takes the full height, sheet(detents) snaps to fixed heights instead, same content shown for both here',
];

export const PresetSheetDemoScreen = () => {
    const navigation = useNavigation();
    const [nickname, setNickname] = useState('');

    return (
        <SheetScreen>
            <ScreenNavBar title="Edit Nickname" closeIconMode="close" onClose={() => navigation.goBack()} />
            <Box padding="s16" gap="s16">
                <Box gap="s4">
                    <Text variant="bodySmall" color={ds.colorToken.text.secondary}>
                        sheet, slides up from the bottom
                    </Text>
                    {BULLETS.map(bullet => (
                        <Text key={bullet} variant="bodySmall" color={ds.colorToken.text.secondary}>
                            {`• ${bullet}`}
                        </Text>
                    ))}
                </Box>
                <Text variant="labelSmall" color={ds.colorToken.text.tertiary}>
                    example below
                </Text>
                <TextInput label="Nickname" value={nickname} onChangeText={setNickname} />
                <Button label="Save" onPress={() => navigation.goBack()} />
            </Box>
        </SheetScreen>
    );
};
